import { AvatarModule } from "../../shared/components/avatar/avatar.module";
import { ModalModule } from "../../shared/components/modal/modal.module";

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ImageCropperModule } from "ngx-image-cropper";
import { MaterialModule } from "../../../modules/material/material.module";

import { OrganizationComponent } from "./organization.component";
import { TeamMemberComponent } from "./teamMemberPicker/team-member.component";
import { TeampageColorPickerComponent } from "./colorPicker/teampage-color-picker.component";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "../../shared/components/layout/header/header.module";
import { SelectionListDeluxeModule } from "../../shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { TeamPageSettingsRoutingModule } from "./teamPageSettings-routing.module";
import { TeamSettingsPreviewModule } from "./teamSettingsPreview/teamSettingsPreview.module";
import { ColorPickerModule } from "../../shared/components/colorPicker/color-picker.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    ModalModule,
    MaterialModule,
    ColorPickerModule,
    ImageCropperModule,
    AvatarModule,
    TeamSettingsPreviewModule,
    HeaderModule,
    PipesModule,
    SelectionListDeluxeModule,
    TeamPageSettingsRoutingModule
  ],
  declarations: [OrganizationComponent, TeamMemberComponent, TeampageColorPickerComponent]
})
export class TeamPageSettingsModule {}
